var __rspack_ns_object = JSON.parse('{"Measurements":"القياسات","Studies":"الدراسات"}')